var _style, _path, _path2, _polyline, _line, _polyline2, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalorieFat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#192852;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.4,7.2L27.4,3c0,0,1.1-1.9,3,0.6c1.9,2.4,5.5,7.8,4.3,12.4c-0.4,1.2-1.6,3.4-4,4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.7,9.8l4.5-6.1c0,0,2.4-3.3,4.9,0c2.6,3.2,7.3,7.7,9.9,18.2c0.2,1.9,2,12.6-8.4,15.5 c-1.9,0.5-9.3,2.4-15-5.2c-0.6-1.5-4-7.1,1.5-17.9"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "14.2,20.2 11,20.2 11,27.1 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11,
    y1: 23,
    x2: 14.2,
    y2: 23
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "16.3,27.1 18.7,20.2 21.6,27.1 "
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17,
    y1: 24.9,
    x2: 20.6,
    y2: 24.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 22.3,
    y1: 20.2,
    x2: 27.8,
    y2: 20.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 25.1,
    y1: 20.5,
    x2: 25.1,
    y2: 27.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalorieFat);
export default __webpack_public_path__ + "static/media/CalorieFat.b11a58108bc404721bf4f409468ce368.svg";
export { ForwardRef as ReactComponent };